function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }


import classNames from 'classnames';
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import PreviewSizeContext from './PreviewSizeContext';
import SrOnly from './SrOnly';
import Text from './Text';
const styles = require('./PreviewItem-styles.module.scss');

function PreviewItem({
  as: Component = 'button',
  active,
  className,
  children,
  ...props
}) {
  const size = useContext(PreviewSizeContext);
  return React.createElement(Component, _extends({}, props, {
    type: Component === 'button' ? 'button' : undefined,
    className: classNames(className, styles.item, active && styles.active),
    style: {
      width: size,
      height: size
    }
  }), children);
}

function PreviewItemPlaceholder({
  className
}) {
  const size = useContext(PreviewSizeContext);
  return React.createElement("div", {
    className: classNames(className, styles.placeholder),
    style: {
      width: size,
      height: size
    }
  });
}

function PreviewItemOverflow({
  as: Component = 'button',
  numOverflowItems,
  ...props
}) {
  const size = useContext(PreviewSizeContext);
  return React.createElement(Component, _extends({}, props, {
    type: Component === 'button' ? 'button' : undefined,
    className: styles.overflow,
    style: {
      width: size,
      height: size
    }
  }), React.createElement(Text, {
    variant: "xl",
    color: "headline",
    "aria-hidden": true
  }, "+", numOverflowItems), React.createElement(SrOnly, null, React.createElement(FormattedMessage, {
    id: "@bfly/ui:previewItem.label",
    defaultMessage: "Show {numOverflowItems} more",
    values: {
      numOverflowItems
    }
  })));
}

PreviewItem.Placeholder = PreviewItemPlaceholder;
PreviewItem.Overflow = PreviewItemOverflow;
export default PreviewItem;